var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"column-center-fullwidth align-center fullheight"},[_c('AgentSignupForm',{attrs:{"error":_vm.error},on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }